import { Component, forwardRef, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslatePipe } from '../../data/pipes/translate.pipe';

export interface SelectOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-select',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent implements ControlValueAccessor {

  @Input() options: SelectOption[] = [];
  @Input() title = 'Language';
  @Input() padding = '12px';
  @Input() selectionEnabled = true;
  @Input() isLoading = false;

  value: string | null = null;
  isOpen = false;
  disabled = false;

  get selectedLabel(): string {
    const selected = this.options.find((opt) => opt.value === this.value);

    return selected ? selected.label : '';
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.select-container')) {
      this.isOpen = false;
    }
  }

  onChange = (_: string): void => {};
  onTouched = (): void => {};

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  toggleDropdown(): void {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
    }
  }

  selectOption(option: SelectOption): void {
    if (!this.selectionEnabled) {
      return;
    }

    this.value = option.value;
    this.onChange(this.value);
    this.onTouched();
    this.isOpen = false;
  }
}
